// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"_2caeN7","result":"_3455Ve","initialViewResult":"_26KjaD","closeArrow":"_156wiW","clearSearchBtn":"ESzpU6","desktopContainer":"_2QM-DZ","isFocused":"_3ZGZdw"};